import { render, staticRenderFns } from "./YwArtificialPatrolPointForm.vue?vue&type=template&id=309ecb09&scoped=true&"
import script from "./YwArtificialPatrolPointForm.vue?vue&type=script&lang=js&"
export * from "./YwArtificialPatrolPointForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309ecb09",
  null
  
)

export default component.exports